/* eslint-disable consistent-return */
import AddressSearch, { EVENT_EDIT_ADDRESS_MANUALLY, EVENT_EDIT_ADDRESS_SEARCH } from '../../components/AddressSearch';
import CheckoutModal from '../../components/CheckoutModal';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import Manipulator from '../../utils/dom/manipulator';
import { ClassNames } from '../../utils/dom/css-classes';
import EventHandler from '../../utils/dom/event-handler';
import { Events } from '../../utils/dom/html-events';
import { clearCart } from '../../api/checkout';
import AddPlayer from '../../components/AddPlayer';
import Select from '../../components/Select';
import Modal from '../../components/Modal';
import Accordion from '../../components/Accordion';
import PaymentMethodSelector from '../../components/PaymentMethodSelector';
import BodyLoader from '../../components/BodyLoader';
import dayjs from 'dayjs';
import { PaymentPage } from '../../components/PaymentMethodSelector/place-order-api';
import FormGenerator from '../../components/FormGenerator';
import { id } from 'common-tags';
import SessionCheckoutSummary from '../../components/SessionCheckoutSummary';
import { EVENT_UPDATE_SESSION_DATA } from '../../components/SessionPlayersList';
import { EVENT_UPDATE_PLAYER_DATA } from '../../components/PlayerList';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import HouseholdAddMember from '../../components/HouseholdAddMember';
import { HOUSEHOLD_ADD_MEMBER_SUCCESS_EXIT } from '../../components/HouseholdAddMember';
import SnackbarNotification from '../../components/SnackbarNotification';
import { householdQuestionRenderers } from '../HouseholdAccounts/formQuestions/questionRenderers';
const SELECTOR_WRAPPER = '.p-checkout';
const SELECTOR_ACCORDION_BUTTON = '.lta-accordion--trigger';
const SELECTOR_COURT_PLAYER_DETAILS = '#p-checkout__court-my-player-details';
const SELECTOR_COURT_PALYER_COUNT_UNDER_18 = '#p-checkout__court-my-player-count';
const SELECTOR_ADD_NEW_MY_PLAYER_TRIGGER_BUTTON = '.js-trigger-add-my-player';
const SELECTOR_SAVE_NEW_MY_PLAYER_BUTTON = '.js-trigger-save-my-new-player';
const SELECTOR_ADD_MY_PLAYER_MODAL = '#add-my-player-modal';
const SELECTOR_ADD_MY_PLAYER_MODAL_EXIT_BTN = '.js-exit-favourite-player-modal-button';
const SELECTOR_ADD_MY_PLAYER_MODAL_QUESTIONS = '.add-my-player-modal-content';
const SELECTOR_ADD_MY_PLAYER_MODAL_CANCEL_BUTTON = '.js-cancel-add-my-new-player-modal-cancel-button';
const SELECTOR_MY_PLAYER_LIST = '.my-player-list';

const SELECTOR_COURT_SAVEHOUSEHOLD_PLAYERS_SNACKBAR_WRAPPER = '.p-checkout__save-household-players-snackbar-wrapper';
const SELECTOR_COURT_HOUSEHOLD_PLAYER_DEtAILS = '#p-checkout__court-household-player-details';
const SELECTOR_COURT_ADD_HOUSEHOLD_MODAL_WRAPPER = '.p-checkout__court-booking-add-new-member-modal-wrapper';
const SELECTOR_COURT_HOUSEHOLD_PLAYER_LIST = '.court-household-player-list';
const SELECTOR_ADD_NEW_COURT_HOUSEHOLD_PLAYER_TRIGGER_BUTTON = '.js-trigger-add-court-household-player';
const SELECTOR_SAVE_NEW_COURT_HOUSEHOLD_PLAYER_BUTTON = '.js-trigger-save-court-household-new-player';

const SELECTOR_EDIT_BUTTON = '#edit-checkout-button';
const SELECTOR_ERROR_WRAPPER = '.p-checkout__submission_error_wrapper';
const SELECTOR_PAYMENT_SECTION = '.p-checkout__payment';
const SELECTOR_ADDRESS_WRAPPER = '.p-checkout__address';
const SELECTOR_ADDRESS_SEARCH = '.p-checkout__address-details';
const SELECTOR_CHECKOUT_MODAL = '.js-checkout-modal';
const SELECTOR_ADDRESS_FORM = '.js-edit-address'; // TODO: Reuse in src/site/_includes/components/CheckoutAddressDetails/CheckoutAddressDetails.js
const SELECTOR_ADDRESS_MODAL = '.lta-modal';
const SELECTOR_ADDRESS_SEARCH_BUTTON = '.js-auto-submit';

const SELECTOR_PLAYER_DETAILS = '.p-checkout__player-details';
const SELECTOR_ADD_PLAYER_TRIGGER_BUTTON = '.js-trigger-add-player';
const SELECTOR_ADD_PLAYER_MODAL = '#add-player-modal';
const SELECTOR_ADD_PLAYER_COMPONENT = '.lta-add-player';
const SELECTOR_ADD_HOUSEHOLD_MEMBER = '.p-household-accounts-add-member-page';
const SELECTOR_PLAYER_LIST = '.add-player-list';
const SELECTOR_INELIGIBLE_PLAYER_LIST = '.js-ineligible-player';
const SELECTOR_HEALTH_CONDITION_CONTAINER = '.p-checkout__additional-Information-health-condition-container';
const SELECTOR_ADDITIONAL_INFO_TEXTAREA = '.p-checkout__additional-Information-textarea';
const SELECTOR_PLAYER_MERCHANDISE_CONTAINER = '.p-checkout__player-merchandise-size';
const SELECTOR_PLAYER_HEALTH_DESCRIPTION = '.p-checkout__additional-Information-description';
const SELECTOR_ERROR_CLASS = '.lta-text-input--error';
const SELECTOR_YOUTH_CONTAINER = '.p-checkout__youth-container';
const SELECTOR_YOUTH_SELF_CONTAINER = '.p-checkout__youth-self';
const SELECTOR_EMERGENCY_CONTACT_CONTAINER = '.p-checkout__emergency-contact';
const SELECTOR_EMERGENCY_CONTACT = '.p-checkout__emergency-contact-number';
const SELECTOR_RELATION_CONTACT = '.p-checkout__emergency-contact-relationship';
const SELECTOR_DISCOUNT_CODE = '.p-checkout__discount-code';
const SELECTOR_DISCOUNT_VALID_CONTAINER = '.p-checkout__discount-code-valid-container';
const SELECTOR_DISCOUNT_VALID_REMOVE = '.p-checkout__discount-code-valid-remove';
const SELECTOR_BOOKING_DETAILS = '.p-checkout__accordion-booking-details';
const SELECTOR_DISCOUNT_PERCENTAGE = '.p-checkout__discount-code-percentage';
const SELECTOR_DISCOUNT_TEXT = '.p-checkout__discount-code-text';
const SELECTOR_CHECKOUT_SUMMARY = '.p-checkout__summary';
const SELECTOR_CHECKOUT_SUMMARY_FORM = '.p-checkout__summary-btw-form';
const SELECTOR_BTW_CHECKOUT_SUMMARY_DETAILS = '.p-btw-checkout-summary-details';
const SELECTOR_BTW_CHECKOUT_SUMMARY_DETAILS_PLAYERNAMES = '.p-btw-summary-details-player-names';

const SELECTOR_SEARCH_ADDRESS_RESULT = '.lta-address-search--result';
const SELECTOR_SEARCH_ADDRESS_FIND = '.lta-address-search--find';
const SELECTOR_SEARCH_ADDRESS_FIND_SUGGEST = '.lta-address-search--find-suggest';
const SELECTOR_SEARCH_ADDRESS_FIND_MANUAL = '.lta-address-search--find-manual';
const SELECTOR_SUGGEST_BUTTON = '.js-auto-submit';
const SELECTOR_MANUAL_BUTTON = '.js-manual-submit';

const EVENT_ADDRESS_FORM_CHANGE = 'change';
const MODAL_HIDE_EVENT = 'hidden.lta.modal';
const CLICK_EVENT = 'click';
const SCROLL_EVENT = 'scroll';
const HIDDEN_CLASS = 'u-hidden';
const STICKY_CLASS = 'sticky';

const SELECTOR_INPUT = 'input';
const SELECTOR_RADIO = 'radio';
const SELECTOR_SELECT = 'select';

const IS_INVALID_CLASS = 'is-invalid';
const IS_FOCUSED_CLASS = 'is-focused';
const HAS_ICON_CLASS = 'has-icon';

const CARD_SELECTED_CLASS = 'p-checkout__card--selected';
const SELECTOR_DISCOUNT_AMOUNT = '.p-checkout__basket-summary-discount-amount';

const DISCOUNT_CODE_NOT_VALID = 'The discount code you’ve entered is not valid';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

const IS_LOCAL = false;
const pickComparisonFields = ({ city, street, state, postCode }) =>
	[city, street, state, postCode].map((value = '') => value.trim());

export const FormTypes = {
	StepForm: 'stepForm',
	SectionForm: 'sectionForm'
};

class Checkout {
	// eslint-disable-next-line complexity
	constructor({ selectors }) {
		this.address = {};
		this.wrapper = SelectorEngine.findOne(selectors.wrapper);
		this.discountAmountValue = undefined;
		this.discountCodeDataValue = undefined;
		this.isValidPlayer = false;
		this.highestStep = undefined;
		this.savedCourtHouseholdPlayerIds = []; // IDs saved on last successful save
		this.currentCourtHouseholdPlayerIds = []; // IDs currently checked
		this.isSavingCourtHouseholdPlayers = false;
		// tracking initial and change player details counts
		this.existingPlayerCount = 0;
		this.changePlayerCount = 0;
		if (this.wrapper) {
			const bodyElement = SelectorEngine.findOne('body');
			if (bodyElement) {
				const bodyLoaderInstance = BodyLoader.getOrCreateInstance(bodyElement);
				bodyLoaderInstance.shouldSkipLoader = true;
			}
			this.courtBookingMaxPlayersAllowed = parseInt(Manipulator.getDataAttribute(this.wrapper, 'court-booking-max-players-allowed'), 10);
			this.courtHouseholdPlayerDetails = SelectorEngine.findOne(selectors.courtHouseholdPlayerDetails, this.wrapper);
			this.courtAdditionalPlayerDetails = SelectorEngine.findOne(selectors.courtAdditionalPlayerDetails, this.wrapper);
			this.courtPlayerCountUnder18 = SelectorEngine.findOne(selectors.courtPlayerCountUnder18, this.wrapper);
			this.paymentSection = SelectorEngine.findOne(selectors.paymentSection, this.wrapper);
			this.errorWrapper = SelectorEngine.findOne(selectors.errorWrapper, this.wrapper);
			this.modal = SelectorEngine.findOne(SELECTOR_CHECKOUT_MODAL, this.wrapper);
			this.editButton = SelectorEngine.findOne(SELECTOR_EDIT_BUTTON, this.wrapper);
			this.playerDetails = SelectorEngine.findOne(SELECTOR_PLAYER_DETAILS, this.wrapper);
			this.addressWrapper = SelectorEngine.findOne(SELECTOR_ADDRESS_WRAPPER, this.wrapper);
			if (this.addressWrapper) {
				this.accordionButton = SelectorEngine.findOne(SELECTOR_ACCORDION_BUTTON, this.addressWrapper);
			}
			this.addressSearchElement = SelectorEngine.findOne(SELECTOR_ADDRESS_SEARCH, this.wrapper);
			if (this.addressSearchElement) {
				this.addressForm = SelectorEngine.findOne(SELECTOR_ADDRESS_FORM, this.addressSearchElement);
				this.addressModal = SelectorEngine.findOne(SELECTOR_ADDRESS_MODAL, this.addressSearchElement);
				this.addressSearchButton = SelectorEngine.findOne(SELECTOR_ADDRESS_SEARCH_BUTTON, this.addressSearchElement);
			}

			this.youthContainer = SelectorEngine.findOne(SELECTOR_YOUTH_CONTAINER, this.wrapper);
			this.isYouthBooking = this.youthContainer !== null;
			this.discountCode = SelectorEngine.findOne(SELECTOR_DISCOUNT_CODE, this.wrapper);
			this.checkoutErrorContainer = SelectorEngine.find('.p-checkout__error-container', this.wrapper);
			if (this.discountCode) {
				this.discountInput = SelectorEngine.findOne('.p-checkout__discount-code-input', this.discountCode);
				this.discountInputElement = SelectorEngine.findOne('input', this.discountInput);
				this.discountApplyButton = SelectorEngine.findOne('.p-checkout__discount-code-apply-button', this.discountCode);
			}
			this.discountValidContainer = SelectorEngine.findOne(SELECTOR_DISCOUNT_VALID_CONTAINER, this.wrapper);
			if (this.discountValidContainer) {
				this.discountValidRemoveButton = SelectorEngine.findOne(
					SELECTOR_DISCOUNT_VALID_REMOVE,
					this.discountValidContainer
				);
				this.discountPercentage = SelectorEngine.findOne(SELECTOR_DISCOUNT_PERCENTAGE, this.discountValidContainer);
				this.discountCodeText = SelectorEngine.findOne(SELECTOR_DISCOUNT_TEXT, this.discountValidContainer);
			}
			if (this.playerDetails) {
				this.addPlayerTriggerButton = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_TRIGGER_BUTTON, this.playerDetails);
				this.addPlayerComponent = SelectorEngine.findOne(SELECTOR_ADD_PLAYER_COMPONENT, this.playerDetails);
				this.addHouseholdMemberComponent = SelectorEngine.findOne(SELECTOR_ADD_HOUSEHOLD_MEMBER, this.playerDetails);
				this.playerList = SelectorEngine.findOne(SELECTOR_PLAYER_LIST, this.playerDetails);
				this.ineligiblePlayerList = SelectorEngine.findOne(SELECTOR_INELIGIBLE_PLAYER_LIST, this.playerDetails);
				this.addPlayerModal = new Modal(SelectorEngine.findOne(SELECTOR_ADD_PLAYER_MODAL, this.playerDetails));
			}

			// for court booking - household members
			if (this.courtHouseholdPlayerDetails) {
				this.courtHouseholdModalWrapper = SelectorEngine.findOne(SELECTOR_COURT_ADD_HOUSEHOLD_MODAL_WRAPPER, this.courtHouseholdPlayerDetails);
				// this.addNewMyPlayerLimit = Manipulator.getDataAttribute(this.courtHouseholdPlayerDetails, 'new-players-allowed');
				this.snackbarWrapper = SelectorEngine.findOne(SELECTOR_COURT_SAVEHOUSEHOLD_PLAYERS_SNACKBAR_WRAPPER, this.courtHouseholdPlayerDetails);
				this.getCourtHouseholdPlayerDetailsApiUrl = Manipulator.getDataAttribute(this.courtHouseholdPlayerDetails, 'get-court-household-player-details-api-url');
				this.maxCourtHouseholdPlayersSelection = Manipulator.getDataAttribute(this.courtHouseholdPlayerDetails, 'court-household-max-players-selectable');
				this.addNewCourtHouseholdPlayerTriggerButton = SelectorEngine.findOne(SELECTOR_ADD_NEW_COURT_HOUSEHOLD_PLAYER_TRIGGER_BUTTON, this.courtHouseholdPlayerDetails);
				this.saveCourtHouseholdPlayersButton = SelectorEngine.findOne(SELECTOR_SAVE_NEW_COURT_HOUSEHOLD_PLAYER_BUTTON, this.courtHouseholdPlayerDetails);
				this.saveCourtHouseholdPlayersApiUrl = Manipulator.getDataAttribute(this.courtHouseholdPlayerDetails, 'save-court-household-players-api-url');
				this.courtHouseholdPlayerList = SelectorEngine.findOne(SELECTOR_COURT_HOUSEHOLD_PLAYER_LIST, this.courtHouseholdPlayerDetails);
			}

			// for court group booking - additional players
			if (this.courtAdditionalPlayerDetails) {
				this.addNewMyPlayerLimit = Manipulator.getDataAttribute(this.courtAdditionalPlayerDetails, 'new-players-allowed');
				this.addNewMyPlayerTriggerButton = SelectorEngine.findOne(SELECTOR_ADD_NEW_MY_PLAYER_TRIGGER_BUTTON, this.courtAdditionalPlayerDetails);
				this.saveNewMyPlayerButton = SelectorEngine.findOne(SELECTOR_SAVE_NEW_MY_PLAYER_BUTTON,	this.courtAdditionalPlayerDetails);
				this.myPlayerList = SelectorEngine.findOne(SELECTOR_MY_PLAYER_LIST, this.courtAdditionalPlayerDetails);
				this.myPlayerModal = SelectorEngine.findOne(SELECTOR_ADD_MY_PLAYER_MODAL, this.courtAdditionalPlayerDetails);
				this.addNewMyPlayerModal = new Modal(SelectorEngine.findOne(SELECTOR_ADD_MY_PLAYER_MODAL, this.courtAdditionalPlayerDetails));
				this.addNewMyPlayerModalExitBtn = SelectorEngine.findOne(SELECTOR_ADD_MY_PLAYER_MODAL_EXIT_BTN, this.courtAdditionalPlayerDetails);
				this.modalQuestions = SelectorEngine.findOne(SELECTOR_ADD_MY_PLAYER_MODAL_QUESTIONS, this.courtAdditionalPlayerDetails);
				this.addNewMyPlayerModalCancelButton = SelectorEngine.findOne(SELECTOR_ADD_MY_PLAYER_MODAL_CANCEL_BUTTON, this.courtAdditionalPlayerDetails);
				this.saveNewAdditionalPlayerApiUrl = Manipulator.getDataAttribute(this.courtAdditionalPlayerDetails, 'save-court-players-api-url');
				this.limitTooltip = SelectorEngine.findOne('.js-lta-tooltip', this.courtAdditionalPlayerDetails);
			}

			this.healthConditionContainer = SelectorEngine.findOne(SELECTOR_HEALTH_CONDITION_CONTAINER, this.wrapper);
			this.additionalTextarea = SelectorEngine.findOne(SELECTOR_ADDITIONAL_INFO_TEXTAREA, this.wrapper);
			if (this.additionalTextarea) {
				this.additionalTextareaDescription = SelectorEngine.findOne(
					SELECTOR_PLAYER_HEALTH_DESCRIPTION,
					this.additionalTextarea
				);
				this.additionalTextareaElement = SelectorEngine.findOne('textarea', this.additionalTextarea);
			}
			if (this.healthConditionContainer) {
				this.healthConditionButtons = SelectorEngine.find(
					'input[name="health-condition"]',
					this.healthConditionContainer
				);
			}
			this.playerMerchandiseSize = SelectorEngine.findOne(SELECTOR_PLAYER_MERCHANDISE_CONTAINER, this.wrapper);
			if (this.playerMerchandiseSize) {
				this.playerMerchandiseElement = SelectorEngine.findOne('.js-lta-select', this.playerMerchandiseSize);
				this.playerMerchandiseSizeSelect =
					Select.getInstance(this.playerMerchandiseElement) || new Select(this.playerMerchandiseElement);
			}
			this.payementSelector = SelectorEngine.findOne('.p-checkout__payment .js-lta-payment', this.wrapper);
			this.youthSelfContainer = SelectorEngine.findOne(SELECTOR_YOUTH_SELF_CONTAINER, this.wrapper);
			this.isYouthBookingByAdult = this.isYouthBooking && !this.youthSelfContainer;
			if (this.isYouthBookingByAdult) {
				this.toggleAddressAccordion(false);
			}

			if (this.payementSelector) {
				this.abtoElement = SelectorEngine.findOne('.payment-method-abto', this.payementSelector);
			}

			this.emergencyContactContainer = SelectorEngine.findOne(SELECTOR_EMERGENCY_CONTACT_CONTAINER, this.wrapper);
			if (this.emergencyContactContainer) {
				this.emergencyContact = SelectorEngine.findOne(SELECTOR_EMERGENCY_CONTACT, this.emergencyContactContainer);
				this.emergencyContactValue = SelectorEngine.findOne(SELECTOR_INPUT, this.emergencyContact);
			}
			this.relationShipContainer = SelectorEngine.findOne(SELECTOR_RELATION_CONTACT, this.wrapper);
			if (this.relationShipContainer) {
				this.relationShipElement = SelectorEngine.findOne('.js-lta-select', this.relationShipContainer);
				this.relationShipSelect = Select.getInstance(this.relationShipElement) || new Select(this.relationShipElement);
			}
			this.bookingDetails = SelectorEngine.findOne(SELECTOR_BOOKING_DETAILS, this.wrapper);
			this.checkoutUrl = Manipulator.getDataAttribute(this.wrapper, 'checkoutUrl');
			if (this.payementSelector) {
				this.termsConditionElement = SelectorEngine.findOne('.terms-and-conditions-selection', this.payementSelector);
				this.submitButton = SelectorEngine.findOne('#payment-btn', this.payementSelector);
				if (this.termsConditionElement) {
					this.submitButton.setAttribute('disabled', 'true');
					EventHandler.on(this.termsConditionElement, 'click', (event) => {
						if (event.target.checked) {
							this.submitButton.removeAttribute('disabled');
						} else {
							this.submitButton.setAttribute('disabled', 'true');
						}
					});
				}
				this.providerName = Manipulator.getDataAttribute(this.payementSelector, 'provider');

				if (this.paymentSection) {
					this.paymentMethods = SelectorEngine.findOne('.payment-method-card', this.paymentSection);
					this.savedCardsDetailsCheckbox = SelectorEngine.findOne('.save-cards-details', this.paymentSection);
					this.savedCardsDetails = SelectorEngine.findOne('.saved-cards-details', this.paymentSection);
					this.savedCardsList = SelectorEngine.findOne('.saved-cards-list', this.paymentSection);
					if (this.savedCardsDetails) {
						this.addAnotherCardButton = SelectorEngine.findOne('.add-another-card--button', this.savedCardsDetails);
						EventHandler.on(this.addAnotherCardButton, CLICK_EVENT, () => {
							this.isFromSavedCard = false;
							this.paymentMethods.classList.remove(HIDDEN_CLASS);
							this.savedCardsDetailsCheckbox.classList.remove(HIDDEN_CLASS);
							this.savedCardsDetails.classList.add(HIDDEN_CLASS);
						});
					}
				}
			}
			this.isFromSavedCard = false;

			const page = window?.lta?.checkout?.screen;
			const provider = window.lta.checkout.paymentSource;
			const courtPrice = provider == 'imin' ? window.lta.imin.basket.totalCost : window.lta.clubspark.basket.totalCost;
			const totalCost = window?.lta?.checkout?.totalCost === undefined ? courtPrice : window?.lta?.checkout?.totalCost;
			const internalPaymentVerification = [PaymentPage.LICENCE_RENEWAL, PaymentPage.ACCREDITATION_RENEWAL].includes(
				page
			);

			if (totalCost && totalCost > 0 && internalPaymentVerification) {
				this.fetchCustomer();
			}

			this.checkoutSummaryElement = SelectorEngine.findOne(SELECTOR_CHECKOUT_SUMMARY, this.wrapper);
			this.checkoutBTWFormElement = SelectorEngine.findOne(SELECTOR_CHECKOUT_SUMMARY_FORM, this.checkoutSummaryElement);
			this.fetchBTWStepsDataAPIUrl = Manipulator.getDataAttribute(this.wrapper, 'checkout-url-events');
			if (this.checkoutBTWFormElement) {
				this.fetchBTWStepsData();
			} else {
				this.init();
			}
		}
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initBTWForm(_stepsData);
		}
	}

	get playersData() {
		return this._playersData;
	}
	set playersData(data) {
		this._playersData = data;
		if (this._playersData.length > 0) {
			this.hidePlayerApiError();
			this.renderPlayerList();
		}
	}

	get courtHouseholdPlayersData() {
		return this._courtHouseholdPlayersData;
	}

	set courtHouseholdPlayersData(data) {
		this._courtHouseholdPlayersData = data;
		if (this._courtHouseholdPlayersData.length > 0) {
			this.renderCourtHouseholdPlayerList();
		}
	}

	get ineligiblePlayersData() {
		return this.additionalPlayersData;
	}

	set ineligiblePlayersData(data) {
		this.additionalPlayersData = data;
		if (this.additionalPlayersData.length > 0) {
			this.renderIneligiblePlayerList();
		}
	}

	get myPlayersData() {
		return this._myPlayersData;
	}

	set myPlayersData(data) {
		this._myPlayersData = Array.isArray(data) ? data : [];
		this.changePlayerCount = this._myPlayersData.length;

		if (this._myPlayersData.length > 0) {
			this.renderMyPlayerList();
		} else {
			this.myPlayerList.innerHTML = '';
		}
	}

	get newPlayerFormData() {
		return this._newPlayerFormData;
	}
	set newPlayerFormData(_newPlayerFormData) {
		this._newPlayerFormData = _newPlayerFormData;
		if (_newPlayerFormData?.length > 0) {
			this.initiateFormGenerator(_newPlayerFormData);
		}
	}

	get savedCardsData() {
		return this._savedCardsData;
	}
	set savedCardsData(data) {
		this._savedCardsData = data;
		if (this._savedCardsData.length > 0) {
			this.renderSaveCards();
		}
	}

	init() {
		this.initStickyOnScroll();

		CheckoutModal.getOrCreateInstance(this.modal);
		if (this.addPlayerComponent) {
			this.addPlayer = new AddPlayer(this.addPlayerComponent);
			this.addPlayer.onExitClick(() => {
				this.addPlayerModal.hide();
			});
			this.addPlayer.onSubmitClick((playerObject) => {
				this.addPlayerModal.hide();
				this.fetchPlayersList('', playerObject);
			});
			this.fetchPlayersList();
		}

		if (this.playerDetails) {
			this.fetchPlayersList();
		}

		if (this.addHouseholdMemberComponent) {
			this.addHouseHoldModal = new HouseholdAddMember(this.addHouseholdMemberComponent);
			document.addEventListener(HOUSEHOLD_ADD_MEMBER_SUCCESS_EXIT, () => {
				this.fetchPlayersList('addingNewMember');
			});
		}

		if (this.courtHouseholdPlayerDetails) {
			this.fetchCourtHouseholdPlayers();
			if (this.courtHouseholdModalWrapper) {
				this.courtBookingAddHouseHoldModal = new HouseholdAddMember(this.courtHouseholdModalWrapper);
				document.addEventListener(HOUSEHOLD_ADD_MEMBER_SUCCESS_EXIT, () => {
					this.fetchCourtHouseholdPlayers('addingNewMember');
				});
			}
		}

		if (
			this.payementSelector &&
			(this.playerDetails ||
				this.courtHouseholdPlayerDetails ||
				this.courtAdditionalPlayerDetails ||
				this.courtPlayerCountUnder18 ||
				this.youthSelfContainer ||
				this.abtoElement ||
				this.savedCardsDetailsCheckbox ||
				this.emergencyContactContainer ||
				this.healthConditionContainer)
		) {
			this.paymentMethodSelector = PaymentMethodSelector.getOrCreateInstance(this.payementSelector);
			// eslint-disable-next-line complexity
			this.paymentMethodSelector.validateOnCheckout = () => {
				let playerIdValue,
					playerSize,
					emergencyContactValue,
					relationShipContact,
					playerhealthCondition,
					playerhealthConditionDescription,
					savedCardIdValue;
				let hasPlayerData = false;
				let hasMyPlayerData = false;
				let hasCourtHouseholdPlayerData = false;
				let hasSavedCardData = false;
				let hasPlayerMerchandiseData = false;
				let hasEmergencyContactValue = false;
				let hasHealthContainerData = false;
				let firstInvalidElement = null;
				let hasRelationShipContainerData = false;
				let hasAddressContainerData = false;
				let playerDetails = [];
				let youthCheckoutConfig = {
					discountAmount: this.discountAmountValue,
					discountCode: this.discountCodeDataValue
				};

				const walletPaymentRadioButton = SelectorEngine.findOne('#wallet-input', this.payementSelector);
				const isWalletSelected = walletPaymentRadioButton?.checked;

				const cardPaymentRadioButton = SelectorEngine.findOne('#card-input', this.payementSelector);
				const isCardSelected = cardPaymentRadioButton?.checked;

				if (this.savedCardsDetailsCheckbox) {
					this.paymentMethodSelector.stripeCustomerRef = this.stripeCustomerRef;

					// uncomment when we introduce save card feature for coaches and officials.
					// if (isWalletSelected) {
					// 	this.savedCardsDetailsCheckbox?.classList.add(HIDDEN_CLASS);
					// } else if (isCardSelected) {
					// 	this.savedCardsDetailsCheckbox?.classList.remove(HIDDEN_CLASS);
					// }
				}

				if (this.totalCost) {
					youthCheckoutConfig = {
						...youthCheckoutConfig,
						totalCost: this.totalCost
					};
				}
				if (this.abtoElement) {
					this.abtoElementCheckbox = SelectorEngine.findOne('#abtoCheck', this.abtoElement);
					this.paymentMethodSelector.abto = this.abtoElementCheckbox?.checked;
				}

				// uncomment when we introduce save card feature for coaches and officials.
				// if (this.savedCardsDetailsCheckbox && isCardSelected) {
				// 	this.savedCardsDetailsCheckboxElement = SelectorEngine.findOne(
				// 		'#SaveCardDetails',
				// 		this.savedCardsDetailsCheckbox
				// 	);
				// 	this.paymentMethodSelector.isSaveCard = this.savedCardsDetailsCheckboxElement?.checked;
				// 	this.paymentMethodSelector.stripeCustomerRef = this.stripeCustomerRef;
				// }

				if (this.addressSearchElement) {
					const isValidAddressValue = this.isValidAddress(this.addressSearchElement);
					if (isValidAddressValue) {
						hasAddressContainerData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							address: this.address
						};
					}
				}

				if (this.playerDetails) {
					playerIdValue = this.validInputValue(this.formElementsList?.playerList);
					const playerObject = this.playersData.find((player) => player.id === playerIdValue);
					if (playerIdValue) {
						hasPlayerData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							playerId: playerIdValue,
							emergencyContactFomPlayer: `${playerObject.contactNo}`,
							name: `${playerObject.firstName} ${playerObject.lastName}`
						};
					}
				}

				// For Court Group Booking Payload
				if (this.myPlayersData && this.courtHouseholdPlayersData) {
					if (this.myPlayersData.length > 0 && this.courtHouseholdPlayersData.length > 0) {
						hasMyPlayerData = true;
						hasCourtHouseholdPlayerData = true;

						const savedPlayers = this.courtHouseholdPlayersData
								.filter((p) => !p.isSelectable || p.isSaved)
								.map((p) => ({
								...p,
								householdFlag: true // BE needed this flag true for every player
							}))
						;
						playerDetails.push(...this.myPlayersData, ...savedPlayers);

						youthCheckoutConfig = {
							...youthCheckoutConfig,
							playerDetails,
							isCourtGroupBookingEnabled: true
						};
					}
				} else if (this.myPlayersData && this.myPlayersData.length > 0) {
					hasMyPlayerData = true;
					playerDetails.push(...this.myPlayersData);

					const isCourtGroupBooking = window?.lta?.checkout?.extraParams?.IsGroupBookingCourt === 'true';

					youthCheckoutConfig = {
						...youthCheckoutConfig,
						playerDetails,
						...(isCourtGroupBooking && { isCourtGroupBookingEnabled: true }) // This value is passed for the user who are 13-17 years old.
					};
				} // For Normal Court Booking Payload
				else if (this.courtHouseholdPlayersData && this.courtHouseholdPlayersData.length > 0) {
					const savedPlayers = this.courtHouseholdPlayersData.filter((p) => !p.isSelectable || p.isSaved);

					if (savedPlayers.length > 0) {
						hasCourtHouseholdPlayerData = true;
						playerDetails.push(...savedPlayers);

						youthCheckoutConfig = {
							...youthCheckoutConfig,
							playerDetails
						};
					}
				}

				if (this.isFromSavedCard && !isWalletSelected) {
					savedCardIdValue = this.validInputValue(this.formElementsList?.savedCardsList);
					if (savedCardIdValue) {
						hasSavedCardData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							paymentId: savedCardIdValue
						};
					}
				}

				if (this.playerMerchandiseSize) {
					playerSize = this.validInputValue(this.formElementsList.playerMerchandiseSize);
					if (playerSize) {
						hasPlayerMerchandiseData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							shirtSize: playerSize
						};
					}
				}

				if (this.emergencyContactContainer) {
					emergencyContactValue = this.validInputValue(this.formElementsList?.emergencyContact);
					if (!emergencyContactValue) {
						hasEmergencyContactValue = false;
						if (!firstInvalidElement) {
							firstInvalidElement = this.emergencyContactContainer;
							this.scrollInToErrorView(firstInvalidElement);
						}
					}
					if (emergencyContactValue) {
						hasEmergencyContactValue = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							emergencyContactNumber: emergencyContactValue
						};
					}
				}

				if (this.relationShipContainer) {
					relationShipContact = this.relationShipSelect._selectNativeElement.value;
					if (relationShipContact) {
						hasRelationShipContainerData = true;
						youthCheckoutConfig = {
							...youthCheckoutConfig,
							relationshipContact: relationShipContact
						};
					}
				}

				if (this.healthConditionContainer) {
					playerhealthCondition = this.validInputValue(this.formElementsList.healthCondition);
					if (playerhealthCondition === 'yes') {
						playerhealthConditionDescription = this.validInputValue(this.formElementsList.healthConditionDescription);

						if (!playerhealthConditionDescription) {
							hasHealthContainerData = false;
							if (!firstInvalidElement) {
								firstInvalidElement = this.additionalTextarea;
								this.scrollInToErrorView(firstInvalidElement);
							}
						} else {
							hasHealthContainerData = true;
							youthCheckoutConfig = {
								...youthCheckoutConfig,
								isPlayerHealthCondition: playerhealthCondition,
								specialRequirements: playerhealthConditionDescription
							};
						}
					} else if (playerhealthCondition === 'no') {
						hasHealthContainerData = true;
						youthCheckoutConfig = {
						...youthCheckoutConfig,
						isPlayerHealthCondition: playerhealthCondition,
						specialRequirements: ''
						};
					} else {
						hasHealthContainerData = false;
						if (!firstInvalidElement) {
							firstInvalidElement = this.healthConditionContainer;
							this.scrollInToErrorView(firstInvalidElement);
						}
					}
				}

				return (!this.playerDetails || hasPlayerData) &&
					(!this.courtHouseholdPlayersData || hasCourtHouseholdPlayerData) &&
					(!this.myPlayersData || hasMyPlayerData) &&
					(!this.playerMerchandiseSize || hasPlayerMerchandiseData) &&
					(!this.emergencyContactContainer || hasEmergencyContactValue) &&
					(!this.healthConditionContainer || hasHealthContainerData) &&
					(!this.addressSearchElement || hasAddressContainerData) &&
					(!this.relationShipContainer || hasRelationShipContainerData) &&
					(!(this.isFromSavedCard && !isWalletSelected) || hasSavedCardData)
					? youthCheckoutConfig
					: false;
			};
		}
		if (this.emergencyContact) {
			this.formElementsList = {
				...this.formElementsList,
				emergencyContact: {
					element: this.emergencyContact,
					formElement: this.emergencyContactValue,
					inputType: SELECTOR_INPUT,
					errorMessage: 'Please enter a emergency contact number',
					hasIcon: false,
					minimumLength: 10,
					inValidErrorMessage: 'Please enter a valid emergency contact number'
				}
			};

			const errorElement = SelectorEngine.findOne(SELECTOR_ERROR_CLASS, this.emergencyContact);
			EventHandler.on(this.emergencyContact, 'input', () => {
				if (this.emergencyContactValue.value.trim().length < this.formElementsList.emergencyContact.minimumLength) {
					this.addInvalidClasses(this.emergencyContact, this.formElementsList.emergencyContact.hasIcon);
					errorElement.innerHTML = this.formElementsList.emergencyContact.inValidErrorMessage;
				} else {
					this.removeInvalidClasses(this.emergencyContact);
					errorElement.innerHTML = '';
				}
			});

			EventHandler.on(this.emergencyContact, 'blur', () => {
				if (this.emergencyContactValue.value.trim().length < this.formElementsList.emergencyContact.minimumLength) {
					this.addInvalidClasses(this.emergencyContact, this.formElementsList.emergencyContact.hasIcon);
					errorElement.innerHTML = this.formElementsList.emergencyContact.inValidErrorMessage;
				} else {
					this.removeInvalidClasses(this.emergencyContact);
					errorElement.innerHTML = '';
				}
			});
		}
		if (this.discountCode) {
			this.formElementsList = {
				...this.formElementsList,
				discountCode: {
					element: this.discountInput,
					formElement: this.discountInputElement,
					inputType: SELECTOR_INPUT,
					errorMessage: 'Please enter discount code',
					hasIcon: false
				}
			};
			EventHandler.on(this.discountApplyButton, CLICK_EVENT, () => {
				const discountCodeValue = this.validInputValue(this.formElementsList.discountCode);
				if (discountCodeValue) {
					this.discountApplyRemove(discountCodeValue);
				}
			});
		}
		if (this.discountValidContainer) {
			EventHandler.on(this.discountValidRemoveButton, CLICK_EVENT, () => {
				this.discountValidContainer.classList.add(HIDDEN_CLASS);
				this.discountCode.classList.remove(HIDDEN_CLASS);
				this.discountInputElement.value = '';
				this.discountApplyRemove('');
			});
		}
		if (this.healthConditionContainer) {
			this.formElementsList = {
				...this.formElementsList,
				healthCondition: {
					element: this.healthConditionContainer,
					formElement: this.healthConditionButtons,
					inputType: SELECTOR_RADIO,
					errorMessage: 'Please select one option',
					hasIcon: false
				},
				healthConditionDescription: {
					element: this.additionalTextareaDescription,
					formElement: this.additionalTextareaElement,
					inputType: SELECTOR_INPUT,
					errorMessage: 'Please enter details here',
					hasIcon: false
				}
			};

			for (const radio of this.healthConditionButtons) {
				EventHandler.on(radio, CLICK_EVENT, () => {
					this.clearFieldError(this.formElementsList.healthCondition);
				});
			}

			EventHandler.on(this.additionalTextareaElement, 'input', () => {
				this.clearFieldError(this.formElementsList.healthConditionDescription);
			});

			EventHandler.on(this.additionalTextareaElement, 'blur', () => {
				this.clearFieldError(this.formElementsList.healthConditionDescription);
			});

			for (const radioButton of this.healthConditionButtons) {
				EventHandler.on(radioButton, CLICK_EVENT, () => {
					const healthValue = this.validInputValue(this.formElementsList.healthCondition);
					if (healthValue === 'yes') {
						this.additionalTextarea.classList.remove(HIDDEN_CLASS);
					} else {
						this.additionalTextarea.classList.add(HIDDEN_CLASS);
					}
				});
			}
		}

		if (this.playerMerchandiseSize) {
			this.formElementsList = {
				...this.formElementsList,
				playerMerchandiseSize: {
					element: this.playerMerchandiseSize,
					formElement: this.playerMerchandiseSizeSelect._selectNativeElement,
					inputType: SELECTOR_SELECT,
					errorMessage: 'Please select size',
					hasIcon: false
				}
			};
			EventHandler.on(this.playerMerchandiseSizeSelect._selectNativeElement, 'change', () => {
				this.validInputValue(this.formElementsList.playerMerchandiseSize);
			});
		}

		if (this.addPlayerTriggerButton) {
			EventHandler.on(this.addPlayerTriggerButton, CLICK_EVENT, () => {
				if (this.addHouseHoldModal.isReady()) {
					this.addHouseHoldModal.open();
				}
			});
		}

		if (this.addNewCourtHouseholdPlayerTriggerButton) {
			EventHandler.on(this.addNewCourtHouseholdPlayerTriggerButton, CLICK_EVENT, () => {
				if (this.courtHouseholdModalWrapper) {
					if (this.courtBookingAddHouseHoldModal.isReady()) {
						this.courtBookingAddHouseHoldModal.open();
					}
				}
			});
		}

		if (this.addNewMyPlayerTriggerButton) {
			EventHandler.on(this.addNewMyPlayerTriggerButton, CLICK_EVENT, () => {
				if (this.getUiSelectedPlayersCount() >= this.courtBookingMaxPlayersAllowed) {
					this.updateAddNewPlayerVisibility();
					return;
				}
				this.addNewMyPlayerModal.show();
				this.addNewPlayerFormSteps();
			});
		}

		EventHandler.on(this.addNewMyPlayerModalCancelButton, CLICK_EVENT, () => {
			this.addNewMyPlayerModal.hide();
			this.formGenerator.unload();
		});

		EventHandler.on(this.addNewMyPlayerModalExitBtn, CLICK_EVENT, () => {
			this.addNewMyPlayerModal.hide();
			this.formGenerator.unload();
		});

		EventHandler.on(this.myPlayerModal, 'hidden.lta.modal', () => {
			this.formGenerator.unload();
		});

		if (this.saveCourtHouseholdPlayersButton) {
			EventHandler.on(this.saveCourtHouseholdPlayersButton, CLICK_EVENT, () => {
				this.handleSavePlayers({ url: this.saveCourtHouseholdPlayersApiUrl });
			});
		}

		if (this.saveNewMyPlayerButton) {
			EventHandler.on(this.saveNewMyPlayerButton, CLICK_EVENT, () => {
				this.handleSavePlayers({ url: this.saveNewAdditionalPlayerApiUrl });
			});
		}

		EventHandler.on(this.addressModal, MODAL_HIDE_EVENT, () => {
			this.addressSearchButton.disabled = false;
		});

		EventHandler.on(this.addressSearchElement, EVENT_EDIT_ADDRESS_MANUALLY, () => {
			this.displayPaymentSection(false);
			this.toggleAddressAccordion(false);

			// for court normal booking and group booking scenario
			if (this.courtHouseholdPlayerDetails) {
				this.displayCourtHousholdPlayerDetails(false);
				this.toggleAddressAccordion(false);
			}

			// for court group booking scenario
			if (this.courtAdditionalPlayerDetails) {
				this.displayCourtAdditionalPlayerDetails(false);
				this.toggleAddressAccordion(false);
			}

			// for court player count under 18 scenario
			if (this.courtPlayerCountUnder18) {
				this.toggleAddressAccordion(false);
				this.displayCourtPlayerCountUnder18(false);
			}

			// for youth booking scenario showing/hiding emergency contact and additional info fields
			if (this.isYouthBooking) {
				this.displayYouthContainer(false);
			}

			// for youth booking hiding player details details
			if (this.playerDetails) {
				this.displayYouthBookingPlayerDetails(false)
			}
		});

		EventHandler.on(this.addressSearchElement, EVENT_EDIT_ADDRESS_SEARCH, () => {
			this.displayPaymentSection(false);
			this.toggleAddressAccordion(false);

			// for court normal booking and group booking scenario
			if (this.courtHouseholdPlayerDetails) {
				this.displayCourtHousholdPlayerDetails(false);
				this.toggleAddressAccordion(false);
			}

			// for court group booking scenario
			if (this.courtAdditionalPlayerDetails) {
				this.displayCourtAdditionalPlayerDetails(false);
				this.toggleAddressAccordion(false);
			}

			// for court player count under 18 scenario
			if (this.courtPlayerCountUnder18) {
				this.toggleAddressAccordion(false);
				this.displayCourtPlayerCountUnder18(false);
			}

			// for youth booking scenario showing/hiding emergency contact and additional info fields
			if (this.isYouthBooking) {
				this.displayYouthContainer(false);
			}

			// for youth booking show player details section
			if (this.playerDetails) {
				this.displayYouthBookingPlayerDetails(false)
			}
		});

		EventHandler.on(this.editButton, Events.Click, () => {
			const { bookingToken } = window.lta[this.providerName].basket;
			clearCart(bookingToken);
		});
		// TODO: This shouldn't be listening to an event defined outside of this file without importing the reference.
		EventHandler.on(this.addressForm, EVENT_ADDRESS_FORM_CHANGE, (event) => {
			const address = event?.detail?.values;
			if (address) {

				// for court normal booking and group booking scenario
				if (this.courtHouseholdPlayerDetails) {
					this.toggleAddressAccordion(true);
					this.displayCourtHousholdPlayerDetails(true);
					this.displayPaymentSection(true);
				}

				// for court normal booking and group booking scenario
				if (this.courtAdditionalPlayerDetails) {
					this.displayCourtAdditionalPlayerDetails(true);
					this.toggleAddressAccordion(true);
				}

				// for court player count under 18 scenario
				if (this.courtPlayerCountUnder18) {
					this.toggleAddressAccordion(true);
					this.displayCourtPlayerCountUnder18(true);
					this.displayPaymentSection(true);
				}

				if (this.isYouthBookingByAdult) {
					this.toggleAddressAccordion(true);
				}

				// for youth booking scenario showing player details section
				if (this.playerDetails) {
					this.displayYouthBookingPlayerDetails(true);	
					if (this.playerListButtons) {
						this.playerListButtons[0]?.click(); // for auto selecting the first player in the list and showing the details on address change for youth booking scenario
					}
				}

				// for youth booking scenario showing/hiding emergency contact and additional info fields
				if (this.youthSelfContainer) {
					this.displayYouthContainer(true);
					this.displayPaymentSection(true);
				}

				// for youth booking by adult scenario, if valid player available after FetchLatestPriceDetails api success, 
				// show sections emergency contact and payment details
				if (this.isValidPlayer) {
					this.displayYouthContainer(true);
					this.displayPaymentSection(true);
				}

				// For accreditation and isLicenseRenewal scenario.
				if (!this.courtHouseholdPlayerDetails && !this.courtAdditionalPlayerDetails && !this.playerDetails && !this.isYouthBooking) {
					this.displayPaymentSection(true)
				}

				if (event.detail.existing) {
					this.address = address;
				} else if (!this.matchAddressValues(this.address, address)) {
					this.submitForm(event);
				}
			}
		});
		this.updateAddNewPlayerVisibility();
	}

	clearFieldError(config) {
		if (!config?.element) return;
		this.removeInvalidClasses(config.element);
	}

	scrollInToErrorView(element) {
		if (!element) return;

		element.scrollIntoView({
			behaviour: 'smooth',
			block: 'center'
		});
	}

	initStickyOnScroll() {
		const stickySection = SelectorEngine.findOne('.enable-sticky', this.wrapper);
		const scrollThreshold = 80;
		this.isHeaderSticky = false;
		if (stickySection !== null) {
			window.addEventListener(SCROLL_EVENT, () => {
				if (window.scrollY > scrollThreshold) {
					if (!this.isHeaderSticky) {
						stickySection.classList.add(STICKY_CLASS);
						this.isHeaderSticky = true;
					}
				} else {
					if (this.isHeaderSticky) {
						stickySection.classList.remove(STICKY_CLASS);
						this.isHeaderSticky = false;
					}
				}
			});
		} else {
			return;
		}
	}

	async handleSavePlayers({ url }) {
		if (!url) {
			console.error('API URL is not set.');
			return;
		}
		let payload;
		const basePayload = {
			userToken: window.lta[this.providerName].user.token,
			...window?.lta?.checkout?.extraParams
		};

		const checkedCheckboxes = SelectorEngine.find('input[type="checkbox"]:checked', this.courtHouseholdPlayerList);

		const selectedSelectableIds = new Set(
			Array.from(checkedCheckboxes).map((checkbox) => String(checkbox.dataset.playerId))
		);

		// Build payload
		const courtHouseholdSelectedPlayers = this.courtHouseholdPlayersData
			?.filter((player) => {
				// Always include non-selectable players which is logged in player
				if (player.isSelectable === false) {
					return true;
				}

				// Include selectable players only if checked
				return selectedSelectableIds.has(String(player.id));
			}).map((player) => player) || [];

		payload = {
			...basePayload,
			courtHouseholdSelectedPlayersDetails: courtHouseholdSelectedPlayers,
			additionalPlayers: this.myPlayersData
		};

		startLoadingAnimation(true);
		try {
			const saveResponse = await Request.post(url, payload, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});

			const {	success, checkOutAccordianHtml, additionalPlayers, courtHouseholdSelectedPlayersDetails, buttonLabel, checkOutErrorHtml, totalCost } = saveResponse;
			stopLoadingAnimation();
			if (success) {
				if (checkOutAccordianHtml && this.bookingDetails) {
					this.bookingDetails.innerHTML = checkOutAccordianHtml;
					this.registerAccordion();
				}

				if (checkOutAccordianHtml && this.bookingDetails) {
					this.bookingDetails.innerHTML = checkOutAccordianHtml;
					this.registerAccordion();
				}

				if (totalCost != undefined && totalCost !== null && window?.lta?.clubspark?.basket) {
					window.lta.clubspark.basket.totalCost = totalCost;
				}

				if (this.submitButton && buttonLabel) {
					this.submitButton.innerHTML = buttonLabel;
				}

				if (courtHouseholdSelectedPlayersDetails.length > 0){
					if (Array.isArray(courtHouseholdSelectedPlayersDetails)) {
						const savedSelectableIds = new Set(
							courtHouseholdSelectedPlayersDetails.filter((p) => p.isSelectable === true).map((p) => String(p.id))
						);

						// Update ID arrays
						this.savedCourtHouseholdPlayerIds = Array.from(savedSelectableIds).sort();
						this.currentCourtHouseholdPlayerIds = [...this.savedCourtHouseholdPlayerIds];

						// Update courtHouseholdPlayersData to include saved selectable players + non-selectable
						this.courtHouseholdPlayersData = this.courtHouseholdPlayersData?.map((player) => {
							if (player.isSelectable === false || savedSelectableIds.has(String(player.id))) {
								return { ...player, isSaved: true }; // mark as saved
							}
							return { ...player, isSaved: false };
						}) || [];

						this.renderCourtHouseholdPlayerList();
						this.showSavePlayerDetailsSuccessSnackbar({ type: 'success', message: 'Player list successfully saved!!' });
					}
				}
				// Updating the local state with latest additionalPlayers from API
				if (additionalPlayers.length > 0) {
					if (Array.isArray(additionalPlayers)) {
						// Will triggers renderMyPlayerList() with updated data from api response
						this.myPlayersData = [...additionalPlayers];
						this.renderMyPlayerList();

						// disable save button after successful save
						this.saveNewMyPlayerButton?.setAttribute('disabled', 'true');

						// enable book now again
						this.submitButton?.removeAttribute('disabled');

						// update UI restrictions
						this.updateAddNewPlayerVisibility();
						this.updateCourtHouseholdPlayerSelectionState();
						this.showSavePlayerDetailsSuccessSnackbar({ type: 'success', message: 'Player added successfully!' });
					}
				}

				this.existingPlayerCount = this.changePlayerCount;
				this.updateAddNewPlayerVisibility();
				this.updateCourtHouseholdPlayerSelectionState();
			} else {
				stopLoadingAnimation();
				if (checkOutErrorHtml) {
					for (const container of this.checkoutErrorContainer) {
						container.innerHTML = checkOutErrorHtml;
					}
					window?.scrollTo?.({
						top: 0,
						behavior: 'smooth'
					});
				}
			}
		} catch (error) {
			stopLoadingAnimation();
			this.showSavePlayerDetailsSuccessSnackbar({
				type: 'error',
				message: error?.statusText || 'Something went wrong. Please try again.'
			});
			console.error('Request failed before response handling:', error);
		} finally {
			stopLoadingAnimation();
		}
	}

	showSavePlayerDetailsSuccessSnackbar({ type = 'success', message = '' }) {
		const container = SelectorEngine.findOne('.js-notification', this.snackbarWrapper);
		if (!container) return;

		const successEl = SelectorEngine.findOne('.js-snackbar-success', container);
		const errorEl = SelectorEngine.findOne('.js-snackbar-error', container);

		// Hide both first
		successEl?.classList.add(ClassNames.Hidden);
		errorEl?.classList.add(ClassNames.Hidden);

		const target = type === 'success' ? successEl : errorEl;
		if (!target) return;

		// Update message
		const label = SelectorEngine.findOne('.lta-snackbar__label', target);
		if (label) label.textContent = message;

		// Show snackbar
		target.classList.remove(ClassNames.Hidden);

		const notification = new SnackbarNotification(container, {
			timeout: 3000
		});

		notification.open();
	}

	async fetchBTWStepsData() {
		startLoadingAnimation(true);
		try {
			const url = this.fetchBTWStepsDataAPIUrl;
			const response = await Request.post(
				url,
				window?.lta?.checkout?.extraParams,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			stopLoadingAnimation();
			if (Steps) {
				this.highestStep = 0;
				for (const element of Steps) {
					if (element.step > this.highestStep) {
						this.highestStep = element.step;
					}
				}
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				stopLoadingAnimation();
				console.log('error', error);
				throw error;
			}
		} catch (error) {
			stopLoadingAnimation();
			console.log('error', error);

			if (error.hasError) {
				console.log('Error : ', error);
			}
		} finally {
			stopLoadingAnimation();
		}
	}

	initBTWForm(stepsData) {
		this.paymentMethodSelector = PaymentMethodSelector.getOrCreateInstance(this.payementSelector);
		this.checkoutEventsFormGenerator = new FormGenerator(this.checkoutBTWFormElement, {
			questions: stepsData,
			totalSteps: this.highestStep,
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			submitButton: {
				title: 'Confirm booking'
			},
			showBottomBackButton: true,
			questionRenderers: householdQuestionRenderers
		});

		this.paymentMethodSelector.onCheckoutError((error) => {
			//TODO: SAMLE ERROR DATA FOR CHECKOUT TO REDIRECT PARTICULAR STEP AND QUESTION
			const { errorData } = JSON.parse(error.errorData);

			this.checkoutEventsFormGenerator?.reRenderForm(errorData);
		});

		this.checkoutEventsFormGenerator.onSubmit((answer) => {
			// TODO: Prepare payload here before passing.
			this.paymentMethodSelector.payload = this.prepareRequestObject(answer);

			if (this.paymentMethodSelector.payload?.['sessionplayers']) {
				this.paymentMethodSelector.payload.sessionplayers = Object.keys(
					this.paymentMethodSelector.payload?.['sessionplayers']
				).map((key) => {
					return {
						sessionId: key,
						players: this.paymentMethodSelector.payload?.['sessionplayers']?.[key]
					};
				});
			}

			SelectorEngine.findOne('#payment-btn')?.click();
		});

		EventHandler.on(SelectorEngine.findOne('body'), EVENT_UPDATE_SESSION_DATA, (data) => {
			if (this.sessionDetails) {
				this.sessionDetails.map((_sessionDetails) => {
					_sessionDetails.updateSessionCheckout(data?.sessions);
				});
			}
		});

		const uniqueNames = new Set();
		const step1Names = [];
		const otherStepNames = [];

		// Collect name of default user
		stepsData
			.filter((step) => step.id === 1)
			.flatMap((step) => step.supportingProps?.players?.map((player) => player.name) || [])
			.forEach((name) => {
				step1Names.push(name);
				uniqueNames.add(name);
			});

		// Collect names from associated children and additional players
		stepsData
			.filter((step) => step.id !== 1)
			.flatMap((step) => step.supportingProps?.players?.map((player) => player.name) || [])
			.forEach((name) => {
				if (!step1Names.includes(name)) {
					otherStepNames.push(name);
				} else if (!uniqueNames.has(name)) {
					otherStepNames.push(name);
					uniqueNames.add(name);
				}
			});

		const playerNamesList = step1Names.concat(otherStepNames);
		const playerNamesCSV = playerNamesList.join(', ');

		this.playerNameElements = SelectorEngine.find(SELECTOR_BTW_CHECKOUT_SUMMARY_DETAILS_PLAYERNAMES, this.wrapper);

		if (this.playerNameElements) {
			this.playerNameElements.map((element) => {
				element.innerHTML = `Players: ${playerNamesCSV}`;
			});
		}

		EventHandler.on(SelectorEngine.findOne('body'), EVENT_UPDATE_PLAYER_DATA, (data) => {
			if (this.playerNameElements) {
				this.playerNameElements.map((_playerElement) => {
					const currentContent = _playerElement.innerHTML;
					_playerElement.innerHTML = currentContent + ', ' + data.updatedData;
				});
			}
		});

		const filteredSessionDatas = stepsData.filter((step) => step.fieldName === 'sessionplayers');
		const sessionsData = filteredSessionDatas[0]?.supportingProps?.sessions;
		this.summaryElements = SelectorEngine.find(SELECTOR_BTW_CHECKOUT_SUMMARY_DETAILS, this.wrapper);

		this.sessionDetails = [];
		if (this.summaryElements) {
			this.summaryElements.map((element) => {
				this.sessionDetails.push(new SessionCheckoutSummary(element, { data: sessionsData }, ''));
			});
		}
	}

	prepareRequestObject(stepsAnswers) {
		let answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				answerList = {
					...answerList,
					...formatObject
				};
			}
		}
		return answerList;
	}

	async addNewPlayerFormSteps() {
		const apiUrl = Manipulator.getDataAttribute(this.courtAdditionalPlayerDetails, 'add-new-my-player-api-url');
		if (!apiUrl) {
			return;
		}
		startLoadingAnimation(true);
		try {
			const url = `${apiUrl}`;
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			stopLoadingAnimation();
			if (Steps) {
				this.newPlayerFormData = Steps;
			}

			if (!!error?.hasError) {
				stopLoadingAnimation();
				throw error;
			}
		} catch (error) {
			stopLoadingAnimation();
			console.log('error', error);

			if (error.hasError) {
				console.log('Error : ', error);
			}
		} finally {
			stopLoadingAnimation();
		}
	}

	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.modalQuestions, {
			questions: stepsData,
			totalSteps: 1,
			hasSeparator: false,
			formType: FormTypes.SectionForm,
			themeColor: '--color-white',
			isHideProgress: true,
			isBackButtonEnabled: false,
			exitButtonHandler: () => {
				this.hideAddNewMyPlayerModal();
			},
			isSubmitButtonEnabled: true,
			submitButton: {
				title: 'Confirm',
				alwaysVisible: true
			}
		});

		// Hook into Confirm button
		this.formGenerator.onSubmit((answer) => {
			const formValues = this.prepareRequestObject(answer);
			// building new player object from form values
			const newPlayer = {
				id: `temp-` + Date.now().toString(), // temporary unique ID
				givenName: formValues.firstName.trim(),
				familyName: formValues.lastName.trim(),
				membershipStatus: formValues.membershipStatus.includes('Member') ? 'Member' : 'Guest',
				isRemovable: true
			};

			// append to existing myPlayersData (triggers renderMyPlayerList automatically)
			this.myPlayersData = [...(this.myPlayersData || []), newPlayer];

			this.updateAddNewPlayerVisibility();

			// close modal & reset
			this.hideAddNewMyPlayerModal();
		});
	}

	// To close new player modal and unload form
	hideAddNewMyPlayerModal = () => {
		this.addNewMyPlayerModal.hide();
		this.formGenerator.unload();
	};

	discountApplyRemove(discountCodeValue) {
		if (this.playerDetails) {
			const playerIdValue = this.validInputValue(this.formElementsList?.playerList);
			const playerObject = this.playersData.find((player) => player.id === playerIdValue);
			this.checkoutValidator(true, discountCodeValue, playerObject);
		} else {
			this.checkoutValidator(true, discountCodeValue);
		}
	}
	isValidAddress(element) {
		this.addressResult = SelectorEngine.findOne(SELECTOR_SEARCH_ADDRESS_RESULT, element);
		this.addressSearchFind = SelectorEngine.findOne(SELECTOR_SEARCH_ADDRESS_FIND, element);
		if (this.addressSearchFind) {
			this.addressSearchFindSuggest = SelectorEngine.findOne(
				SELECTOR_SEARCH_ADDRESS_FIND_SUGGEST,
				this.addressSearchFind
			);
			this.addressSearchFindManual = SelectorEngine.findOne(
				SELECTOR_SEARCH_ADDRESS_FIND_MANUAL,
				this.addressSearchFind
			);
		}
		let isAddressAvailable = true;
		if (this.addressResult.classList.contains(HIDDEN_CLASS)) {
			isAddressAvailable = false;
			if (this.addressSearchFind) {
				if (!this.addressSearchFindSuggest.classList.contains(HIDDEN_CLASS)) {
					const suggestFormButton = SelectorEngine.findOne(SELECTOR_SUGGEST_BUTTON, this.addressSearchFindSuggest);
					suggestFormButton.click();
				}

				if (!this.addressSearchFindManual.classList.contains(HIDDEN_CLASS)) {
					const manualFormButton = SelectorEngine.findOne(SELECTOR_MANUAL_BUTTON, this.addressSearchFindManual);
					manualFormButton.click();
				}
			}
		}
		return isAddressAvailable;
	}
	// eslint-disable-next-line complexity
	async checkoutValidator(isCallFromDiscount, discountValue, playerObject = {}) {
		startLoadingAnimation(true);
		try {
			const url = this.checkoutUrl;
			const dataObject = {
				userToken: window.lta[this.providerName].user.token,
				discountCode: discountValue,
				playerId: playerObject.id,
				playerName: `${playerObject.firstName} ${playerObject.lastName}`,
				dateOfBirth: playerObject.dateOfBirth,
				playerGender: playerObject.gender,
				emergencyContactFomPlayer: `${playerObject.contactNo}`
			};
			const response = await Request.get(url, dataObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { success, error, checkOutAccordianHtml, discountPercent, checkOutErrorHtml, discountAmount, totalCost } =
				response;
			stopLoadingAnimation();
			if (success) {
				this.bookingDetails.innerHTML = checkOutAccordianHtml;
				this.registerAccordion();
				this.totalCost = totalCost;
				if (!error.showDiscountInvalidError && isCallFromDiscount) {
					if (discountValue !== '') {
						this.discountValidContainer.classList.remove(HIDDEN_CLASS);
						this.discountCode.classList.add(HIDDEN_CLASS);

						this.discountPercentage.innerHTML = Number.parseInt(discountPercent, 10);
						this.discountCodeText.innerHTML = discountValue.toString().toUpperCase();
						this.discountInputElement.value = '';
					}

					this.discountCodeDataValue = discountValue.toString();
					const discountAmountData = SelectorEngine.findOne(SELECTOR_DISCOUNT_AMOUNT, this.wrapper);
					if (discountAmountData) {
						const discountAmountHTMLValue = discountAmountData.innerHTML;
						if (discountAmountHTMLValue) {
							this.discountAmountValue = discountAmount;
						}
					}
				} else {
					this.isValidPlayer = true;
					this.youthContainer.classList.remove(HIDDEN_CLASS);
					this.displayPaymentSection(true);
				}
			} else {
				if (!isCallFromDiscount) {
					this.isValidPlayer = false;
					// For bug 33764: Commented out below line as per discussion with team, even for youth booking by adult scenario, if player is not valid then we need to hide emergency contact and payment section
					// if (!this.isYouthBookingByAdult) { 
					this.youthContainer.classList.add(HIDDEN_CLASS);
					this.displayPaymentSection(false);
					// }
				}
				if (error.showDiscountInvalidError && isCallFromDiscount) {
					this.discountValidContainer.classList.add(HIDDEN_CLASS);
					this.discountCode.classList.remove(HIDDEN_CLASS);

					this.addInvalidClasses(this.discountInput, false);
					const errorElement = SelectorEngine.findOne(SELECTOR_ERROR_CLASS, this.discountInput);
					errorElement.innerHTML = DISCOUNT_CODE_NOT_VALID;
				}
				if (error.showAgeValidationError && !isCallFromDiscount) {
					this.addInvalidClasses(this.playerList, false);
					const errorElement = SelectorEngine.findOne(SELECTOR_ERROR_CLASS, this.playerList);
					errorElement.innerHTML = error?.ageValidationMessage;
				}
				if (error.isRedirectUser && !isCallFromDiscount) {
					window.location.href = error.redirectUrl;
				}
				if (!isCallFromDiscount && checkOutErrorHtml) {
					for (const container of this.checkoutErrorContainer) {
						container.innerHTML = checkOutErrorHtml;	
					}
					window?.scrollTo?.({
						top: 0,
						behavior: 'smooth'
					});
				}
			}
		} catch (error) {
			stopLoadingAnimation();
			if (!isCallFromDiscount) {
				this.isValidPlayer = false;
				if (!this.isYouthBookingByAdult) {
					this.youthContainer.classList.add(HIDDEN_CLASS);
					this.displayPaymentSection(false);
				}
			}
			if (error.hasError) {
				// eslint-disable-next-line no-console
				console.log('Error :', error);
			}
		} finally {
			stopLoadingAnimation();
		}
	}
	registerAccordion() {
		const accordions = SelectorEngine.find('.lta-accordion', this.bookingDetails);
		for (const accordion of accordions) {
			Accordion.getOrCreateInstance(accordion);
		}
	}
	validInputValue(elementObject) {
		let formElementValue;
		switch (elementObject.inputType) {
			case SELECTOR_INPUT: {
				if (elementObject.minimumLength) {
					formElementValue = elementObject.formElement.value.trim();
					if (elementObject.minimumLength && formElementValue.length < elementObject.minimumLength) {
						this.addInvalidClasses(elementObject.element, elementObject.hasIcon);
						const errorElement = SelectorEngine.findOne(SELECTOR_ERROR_CLASS, elementObject.element);
						errorElement.innerHTML = elementObject.inValidErrorMessage || elementObject.errorMessage;
						return '';
					}
				} else {
					formElementValue = elementObject.formElement.value;
				}

				break;
			}
			case SELECTOR_RADIO: {
				for (const radioButton of elementObject.formElement) {
					if (radioButton.checked) {
						formElementValue = radioButton.value;
					}
				}

				break;
			}
			case SELECTOR_SELECT: {
				formElementValue = elementObject.formElement.value;

				break;
			}
			// No default
		}
		const errorElement = SelectorEngine.findOne(SELECTOR_ERROR_CLASS, elementObject.element);
		if (!formElementValue) {
			this.addInvalidClasses(elementObject.element, elementObject.hasIcon);
			errorElement.innerHTML = elementObject.errorMessage;
			return '';
		} else {
			this.removeInvalidClasses(elementObject.element);
			errorElement.innerHTML = '';
			return formElementValue;
		}
	}
	addInvalidClasses(element, hasIcon) {
		element.classList.add(IS_INVALID_CLASS);
		element.classList.add(IS_FOCUSED_CLASS);
		if (hasIcon) {
			element.classList.add(HAS_ICON_CLASS);
		}
	}
	removeInvalidClasses(element) {
		element.classList.remove(IS_INVALID_CLASS);
		element.classList.remove(IS_FOCUSED_CLASS);
		element.classList.remove(HAS_ICON_CLASS);
	}
	async fetchPlayersList(refetchingStatus, selectedPlayerID) {
		startLoadingAnimation(true);
		try {
			const url = `/api/player/getplayers`;
			const params = {
				checkoutType: 'Youth course'
			};

			// Conditionally adding refetchingStatus only for only FE testing
			if (refetchingStatus !== undefined) {
				params.refetchingStatus = refetchingStatus;
			}

			const response = await Request.get(
				url,
				params,
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);

			const playerDetails = response?.playerDetails || [];
			const pendingInvitationPlayers = response?.pendingInvitationPlayers || [];
			const pendingInvitationHeaderDescription = response?.pendingInvitationHeaderDescription || "";
			const error = response?.error || {};

			if (playerDetails.length === 0) {
				this.submitButton?.setAttribute('disabled', 'true');
			} else {
				this.submitButton?.removeAttribute('disabled');
			}

			if (error?.hasError) {
				this.showPlayerApiError(error.errorMessage, error.errorSubtitle);
			} else {
				this.selectedPlayerDataID = selectedPlayerID ? selectedPlayerID.id : undefined;
				this.playersData = [...playerDetails];
			}

			this.ineligiblePlayerDescription = pendingInvitationHeaderDescription;
			this.ineligiblePlayersData = [...pendingInvitationPlayers];
		} catch (error) {
			stopLoadingAnimation();
			if (error?.hasError) {
				this.showPlayerApiError(error.errorMessage, error.errorSubtitle);
			}
		} finally {
			stopLoadingAnimation();
		}
	}

	async fetchCourtHouseholdPlayers(refetchingStatus) {
		if (!this.getCourtHouseholdPlayerDetailsApiUrl) {
			console.error('getCourtHouseholdPlayerDetailsApiUrl not set');
			return;
		}
		startLoadingAnimation(true);
		try {
			const params = {
				checkoutType: 'Court'
			};

			
			if (window?.lta?.checkout?.paymentSource == 'imin') {
				params.source = 'imin';
			}

			// Conditionally adding refetchingStatus only for only FE testing
			if (refetchingStatus !== undefined) {
				params.refetchingStatus = refetchingStatus;
			}
			const url = `${this.getCourtHouseholdPlayerDetailsApiUrl}`;
			const response = await Request.get(
				url,
				params,
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			stopLoadingAnimation();

			const playerDetails = response?.playerDetails || [];
			const pendingInvitationPlayers = response?.pendingInvitationPlayers || [];
			const pendingInvitationHeaderDescription = response?.pendingInvitationHeaderDescription || '';
			const error = response?.error || {};

			this.pendingInvitationPlayerDetails = [...pendingInvitationPlayers];
			this.pendingInvitationHeaderDescription = pendingInvitationHeaderDescription;
			this.courtHouseholdPlayersData = [...playerDetails] || [];

			if (error?.hasError) {
				this.showPlayerApiError(error.errorMessage);
			}
		} catch (error) {
			if (error.hasError) {
				stopLoadingAnimation();
				// eslint-disable-next-line no-console
				console.error('Error :', error);
			}
		} finally {
			stopLoadingAnimation();
		}
	}

	async fetchCustomer() {
		try {
			const url = `/api/payments/customer`;
			const response = await Request.post(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { RegisteredCards, StripeCustomerRef } = response;
			this.registeredCards = [...RegisteredCards];
			this.stripeCustomerRef = StripeCustomerRef;
			// These need to uncommented when we introduce the feature save card details. At present this feature is not implemented completely and breaking on license renewal pages when we get registered card details from saleforce.
			// if (this.registeredCards?.length > 0) {
			// 	this.isFromSavedCard = true;
			// 	this.paymentMethods.classList.add(HIDDEN_CLASS);
			// 	this.savedCardsDetailsCheckbox?.classList.add(HIDDEN_CLASS);
			// 	this.savedCardsDetails.classList.remove(HIDDEN_CLASS);
			// 	this.savedCardsData = this.registeredCards;
			// }
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	buttonClassToggle() {
		this.playerCards = SelectorEngine.find('.p-checkout__player-details-card', this.playerList);
		for (const card of this.playerCards) {
			EventHandler.on(card, CLICK_EVENT, this.selectCard.bind(this));
		}
		if (this.addPlayerTriggerButton) {
			if (this.playerCards?.length > 0) {
				this.addPlayerTriggerButton.classList.remove('lta-btn--primary');
				this.addPlayerTriggerButton.classList.add('lta-btn--link');
				this.addPlayerTriggerButton.classList.add('is-list');
			} else {
				this.addPlayerTriggerButton.classList.add('lta-btn--primary');
				this.addPlayerTriggerButton.classList.remove('lta-btn--link');
				this.addPlayerTriggerButton.classList.remove('is-list');
			}
		}
	}
	selectCard(event) {
		const cardCheckBox = SelectorEngine.findOne('input[type="radio"]', event.currentTarget);
		cardCheckBox.click();
	}

	addClassSelected(event, cards) {
		for (const card of cards) {
			if (card === event.target.parentElement) {
				card.classList.add(CARD_SELECTED_CLASS);
			} else {
				card.classList.remove(CARD_SELECTED_CLASS);
			}
		}
	}

	removePlayerCard() {
		if (!this.playerCards) {
			return;
		}
		for (const card of this.playerCards) {
			card.remove();
		}
	}

	getLoggedInUserCount() {
		return 1;
	}

	getSavedHouseholdPlayers() {
		if (!this.courtHouseholdPlayersData) return [];
		return this.courtHouseholdPlayersData?.filter((p) => !p.isSelectable || p.isSaved === true) || [];
	}

	getAdditionalPlayers() {
		return Array.isArray(this.myPlayersData) ? this.myPlayersData : [];
	}

	getTotalPlayersCount() {
		return this.getLoggedInUserCount() + this.getSavedHouseholdPlayers().length + this.getAdditionalPlayers().length;
	}

	isPlayerLimitReached() {
		return this.getTotalPlayersCount() >= this.courtBookingMaxPlayersAllowed;
	}

	getUiSelectedPlayersCount() {
		// Count currently checked household players in UI
		let householdCheckedCount = 0;

		if (this.courtHouseholdPlayerList) {
			const checked = SelectorEngine.find('.js-court-household-player-checkbox:checked', this.courtHouseholdPlayerList);
			householdCheckedCount = checked.length;
		}

		// Count additional players in UI
		const additionalPlayersCount = Array.isArray(this.myPlayersData) ? this.myPlayersData.length : 0;

		// Total players = fixed logged in user + household checked + additional
		return this.getLoggedInUserCount() + householdCheckedCount + additionalPlayersCount;
	}

	updateAddNewPlayerVisibility() {
		if (!this.addNewMyPlayerTriggerButton || !this.limitTooltip) return;

		const totalSelectedPlayers = this.getUiSelectedPlayersCount();

		if (totalSelectedPlayers >= this.courtBookingMaxPlayersAllowed) {
			this.addNewMyPlayerTriggerButton.classList.add(HIDDEN_CLASS);
			this.limitTooltip.classList.remove(HIDDEN_CLASS);
		} else {
			this.addNewMyPlayerTriggerButton.classList.remove(HIDDEN_CLASS);
			this.limitTooltip.classList.add(HIDDEN_CLASS);
		}
	}

	renderCourtHouseholdPlayerList() {
		this.courtHouseholdPlayerList.innerHTML = ''; // remove old cards

		this.courtHouseholdPlayerList.innerHTML = this.courtHouseholdPlayersData
			?.map((data) => this.renderCourtHouseholdPlayerCard(data))
			.join('');

		if (this.pendingInvitationPlayerDetails?.length > 0) {
			if (this.pendingInvitationHeaderDescription) {
				this.courtHouseholdPlayerList.innerHTML += `
					<div class="p-checkout__player-info-message u-body1 u-text-grey-lta">
						${this.pendingInvitationHeaderDescription}
					</div>
				`;
			}

			this.courtHouseholdPlayerList.innerHTML += this.pendingInvitationPlayerDetails
				.map((data) => this.renderAdditionalPlayerCard(data))
				.join('');
		}

		this.playerListButtons = SelectorEngine.find('input[type="checkbox"]', this.courtHouseholdPlayerList);

		if (this.playerDetails) {
			this.formElementsList = {
				...this.formElementsList,
				courtHouseholdPlayerList: {
					element: this.courtHouseholdPlayerList,
					formElement: this.playerListButtons,
					inputType: SELECTOR_CHECKBOX,
					errorMessage: 'Please select one player option',
					hasIcon: false
				}
			};
		}

		this.courtHouseholdPlayerCardClickHandler();
		this.updateCourtHouseholdPlayerSelectionState();
		this.bindCourtHouseholdCheckboxEvents();

		this.savedCourtHouseholdPlayerIds = this.getSelectedCourtHouseholdPlayerIds();

		this.currentCourtHouseholdPlayerIds = [...this.savedCourtHouseholdPlayerIds];
		this.updateAddNewPlayerVisibility();
		// initial button state
		this.disableSaveEnableBookNow();
	}

	bindCourtHouseholdCheckboxEvents() {
		const checkboxes = SelectorEngine.find('.js-court-household-player-checkbox', this.courtHouseholdPlayerList);

		Array.from(checkboxes).forEach((checkbox) => {
			EventHandler.off(checkbox, 'change');

			EventHandler.on(checkbox, 'change', (e) => {
				this.onCourtHouseholdSelectionChange();
			});
		});
	}

	onCourtHouseholdSelectionChange() {
		this.currentCourtHouseholdPlayerIds = this.getSelectedCourtHouseholdPlayerIds();

		const hasUnsavedChanges =
			this.currentCourtHouseholdPlayerIds.join(',') !== this.savedCourtHouseholdPlayerIds.join(',');

		if (hasUnsavedChanges) {
			this.enableSaveDisableBookNow();
		} else {
			this.disableSaveEnableBookNow();
		}

		this.updateCourtHouseholdPlayerSelectionState();
		this.updateAddNewPlayerVisibility();
	}

	getSelectedCourtHouseholdPlayerIds() {
		const checked = SelectorEngine.find('.js-court-household-player-checkbox:checked', this.courtHouseholdPlayerList);

		return Array.from(checked)
			.map((cb) => String(cb.dataset.playerId))
			.sort();
	}

	enableSaveDisableBookNow() {
		if (this.isSavingCourtHouseholdPlayers) return;

		this.saveCourtHouseholdPlayersButton?.removeAttribute('disabled');
		this.submitButton?.setAttribute('disabled', 'true');
	}

	disableSaveEnableBookNow() {
		if (this.isSavingCourtHouseholdPlayers) return;

		// disable both save buttons only if no pending changes
		this.saveCourtHouseholdPlayersButton?.setAttribute('disabled', 'true');

		// disable additional save only if no additional players added
		if (!this.myPlayersData || this.myPlayersData.length === 0) {
			this.saveNewMyPlayerButton?.setAttribute('disabled', 'true');
		}

		// enable book now
		this.submitButton?.removeAttribute('disabled');
	}

	renderCourtHouseholdPlayerCard(playerData) {
		const isSelectable = playerData.isSelectable === true;
		const isChecked = playerData.isSelectable === false || playerData.isSaved;

		return `
			<div 
				class="p-checkout__player-details-card lta-form-check u-hstack g-col-12 g-col-md-6 u-h-100
				${isSelectable ? 'is-selectable' : ''}"
				data-player-card
			>
				${
					isSelectable
						? `<input
							class="lta-form-check-input u-mr-2 js-court-household-player-checkbox"
							type="checkbox"
							name="court-household-player"
							value="${playerData.id}"
							data-player-id="${playerData.id}"
              				${isChecked ? 'checked' : ''}

						/>`
						: ''
				}
				<div class="p-checkout__player-details-record u-bg-background-blue u-px-3 u-py-2 u-rounded u-h-100">
					<div class="u-caption1 u-text-grey-lta">
						${playerData.firstName} ${playerData.lastName}
					</div>
					<div class="u-body1 u-text-grey-lta">
						Age: ${this.getAge(playerData.dateOfBirth)}
					</div>
					<div class="u-body1 u-text-grey-lta">
						${playerData.gender}
					</div>
					${playerData.membershipStatus 
						? `<div class="u-body1 u-text-grey-lta"> ${playerData.membershipStatus} </div>`
						: ''
					}
					</div>
				</div>
			</div>
		`;
	}

	updateCourtHouseholdPlayerSelectionState() {
		if (!this.courtHouseholdPlayerList) return;

		const allCards = SelectorEngine.find('[data-player-card]', this.courtHouseholdPlayerList);

		const checkedCheckboxes = SelectorEngine.find(
			'.js-court-household-player-checkbox:checked',
			this.courtHouseholdPlayerList
		);

		const additionalPlayersCount = this.getAdditionalPlayers().length;

		// remaining slots available for household selection
		const remainingSlotsForHousehold = this.courtBookingMaxPlayersAllowed - this.getLoggedInUserCount() - additionalPlayersCount;

		const isLimitReached = checkedCheckboxes.length >= remainingSlotsForHousehold;

		for (const card of allCards) {
			const checkbox = SelectorEngine.findOne('.js-court-household-player-checkbox', card);

			if (!checkbox) continue;

			// If limit reached and checkbox is not checked -> disable it
			if (isLimitReached && !checkbox.checked) {
				checkbox.disabled = true;
				card.classList.add('is-disabled');
			} else {
				checkbox.disabled = false;
				card.classList.remove('is-disabled');
			}
		}

		this.updateAddNewPlayerVisibility();
	}

	courtHouseholdPlayerCardClickHandler() {
		const cards = SelectorEngine.find('[data-player-card]', this.courtHouseholdPlayerList);

		cards.forEach((card) => {
			EventHandler.off(card, 'click');

			EventHandler.on(card, 'click', (e) => {
				if (e.target.matches('input[type="checkbox"]')) {
					return;
				}

				const checkbox = card.querySelector('.js-court-household-player-checkbox');

				if (checkbox && !checkbox.disabled) {
					checkbox.checked = !checkbox.checked;
					checkbox.dispatchEvent(new Event('change', { bubbles: true }));
				}
			});
		});
	}

	renderIneligiblePlayerList() {
		if (!this.ineligiblePlayerList || !this.additionalPlayersData?.length) return;

		const descriptionHTML = this.ineligiblePlayerDescription
			? `<p class="p-checkout__player-info-message u-body1 u-text-grey-lta u-my-2">
                    ${this.ineligiblePlayerDescription}
            </p>`
			: '';

		const cardsHTML = this.additionalPlayersData.map((data) => this.renderAdditionalPlayerCard(data)).join('');

		this.ineligiblePlayerList.innerHTML = descriptionHTML + cardsHTML;
	}

	renderPlayerList() {
		this.removePlayerCard(); // Removed old cards when re-renders the new one.
		this.playerList.innerHTML += this.playersData.map((data) => this.renderPlayerCard(data)).join('');
		this.buttonClassToggle();
		this.playerListButtons = SelectorEngine.find('input[name="player-details"]', this.playerList);
		if (this.playerDetails) {
			this.formElementsList = {
				...this.formElementsList,
				playerList: {
					element: this.playerList,
					formElement: this.playerListButtons,
					inputType: SELECTOR_RADIO,
					errorMessage: 'Please select one player option',
					hasIcon: false
				}
			};
		}
		if (this.playerListButtons) {
			this.playerListButtons.forEach((radioButton, index) => {
				EventHandler.on(radioButton, CLICK_EVENT, this.playerCardClickHandler.bind(this));
			});

			const alreadySelected = [...this.playerListButtons].some((rb) => rb.checked);

			if (!alreadySelected && this.playerListButtons.length > 0) {
				this.playerListButtons[0].click();
			}
		}
	}

	renderMyPlayerList() {
		this.myPlayerList.innerHTML = ''; // clear old
		this.myPlayerList.innerHTML = this.myPlayersData.map((data) => this.renderMyPlayerCard(data)).join('');

		// Attach event listeners to remove buttons
		this.myPlayerList.querySelectorAll('.js-remove-player').forEach((btn) => {
			btn.addEventListener('click', (e) => this.removePlayer(e));
		});
		this.saveNewMyPlayerButton?.removeAttribute('disabled');
		this.submitButton?.setAttribute('disabled', 'true');
		this.updateAddNewPlayerVisibility();
		this.updateCourtHouseholdPlayerSelectionState();
	}

	removePlayer(event) {
		const playerId = event.currentTarget.getAttribute('data-id');

		this.myPlayersData = this.myPlayersData.filter((player) => String(player.id) !== String(playerId));

		// after removal update household limits
		this.updateAddNewPlayerVisibility();
		this.updateCourtHouseholdPlayerSelectionState();

		// enable save + disable book now
		this.saveNewMyPlayerButton?.removeAttribute('disabled');
		this.submitButton?.setAttribute('disabled', 'true');
	}

	playerCardClickHandler(event) {
		event.stopPropagation();
		this.addClassSelected(event, this.playerCards);
		this.validInputValue(this.formElementsList.playerList);
		const playerObject = this.playersData.find((player) => player.id === event.target.value);
		// restricting checkout validation call only when player details section is not visible to avoid unnecessary calls.
		if (!this.playerDetails.classList.contains(HIDDEN_CLASS)) {
			this.checkoutValidator(false, '', playerObject);
		}
		if (playerObject && this.playerMerchandiseSize && playerObject.address) {
			this.changeAddressOnPlayerSelect(playerObject.address);
		}
	}

	changeAddressOnPlayerSelect(playerObjectAddress) {
		this.address = {
			street: playerObjectAddress?.streetAddress,
			city: playerObjectAddress?.addressLocality,
			state: playerObjectAddress?.addressRegion,
			postCode: playerObjectAddress?.postalCode
		};
		const playerMerchandiseAddress = SelectorEngine.findOne(
			'.js-retrive-address',
			this.playerMerchandiseSize.parentElement
		);
		const addressSearchObject = AddressSearch.getInstance(playerMerchandiseAddress);
		addressSearchObject.disbaleFocus = true;
		addressSearchObject.populateManualForm(this.address, false);
	}

	getAge(dateString) {
		const dateObject = dayjs(new Date());
		return dateObject.diff(dayjs(dateString), 'year');
	}

	renderPlayerCard(playerData) {
		return `
		<div class="p-checkout__player-details-card ${
			this.selectedPlayerDataID === playerData.id ? CARD_SELECTED_CLASS : ''
		} lta-form-check lta-form-check u-hstack g-col-12 g-col-md-6 u-h-100 u-py-1">
			<input
				class="lta-form-check-input u-mr-2"
				role="radio"
				type="radio"
				name="player-details"
				value="${playerData.id}"
				aria-label=""
				data-player-id="${playerData.id}" 
				${this.selectedPlayerDataID === playerData.id ? 'checked' : ''}/>
					<div class="p-checkout__player-details-record u-bg-background-blue u-px-3 u-py-2 u-rounded u-h-100">
						<div class="u-caption1 u-text-grey-lta">${playerData.firstName} ${playerData.lastName}</div>
						<div class="u-body1 u-text-grey-lta">Age: ${this.getAge(playerData.dateOfBirth)}</div>
						<div class="u-body1 u-text-grey-lta">${playerData.gender}</div>
						<div class="u-body1 u-text-grey-lta u-hidden">Emergency contact:${playerData.contactNo}</div>
					</div>
			</div>`;
	}

	renderAdditionalPlayerCard(playerData) {
		return `
			<div class="p-checkout__player-details-card	u-hstack g-col-12 g-col-md-6 u-h-100">
				<div class="p-checkout__player-details-record u-bg-grey-light u-px-3 u-py-2 u-rounded u-h-100">
					<div class="u-caption1 u-text-grey-lta">
						${playerData.firstName} ${playerData.lastName}
					</div>
					<div class="u-body1 u-text-grey-lta">
						Age: ${this.getAge(playerData.dateOfBirth)}
					</div>
					<div class="u-body1 u-text-grey-lta">
						${playerData.gender}
					</div>
				</div>
			</div>`;
	}

	renderMyPlayerCard(myPlayerData) {
		return `
		<div class="p-checkout__my-player-details-card g-col-12 g-col-md-6 u-h-100">
			<div class="p-checkout__player-details-record u-bg-background-blue u-flex u-justify-space-between u-align-baseline u-p-2 u-gap-1 u-rounded u-h-100">
				<div class="u-vstack">
					<div class="u-h5 u-text-grey-lta" style="line-break: anywhere;">
						${myPlayerData.givenName} ${myPlayerData.familyName}
					</div>
					<div class="u-body1 u-fw-medium u-text-grey-lta">
						${myPlayerData.membershipStatus === 'Member' ? 'Member' : 'Guest'}
					</div>
				</div>
				${myPlayerData?.isRemovable
					? `<div class="u-ml-auto">
						<button type="button" class="u-caption1 u-text-lta-blue lta-btn lta-btn--lg lta-btn--link js-remove-player" data-id=${myPlayerData.id}>Remove</button>
					</div>`
					: ''
				}
			</div>
		</div>`;
	}

	showPlayerApiError(message, subtitle) {
		const errorContainer = SelectorEngine.findOne('.p-checkout__player-api-error', this.wrapper);

		if (!errorContainer) return;

		const snackbarHTML = `
			<div class="lta-snackbar lta-snackbar--hard-alert has-icon" style="max-width: 100%">
				<p class="lta-snackbar__label title" aria-label="${message}">${message}</p>
				${subtitle ? `<p class="text">${subtitle}</p>` : ''}
				<div class="lta-snackbar__icon">
					<svg class="fe-icon" width="1em" height="1em">
						<use xlink:href="/static/images/icons/lta-icons.svg#alert-circle-no-fill"></use>
					</svg>
				</div>
			</div>
		`;

		errorContainer.innerHTML = snackbarHTML;

		errorContainer.classList.remove('u-hidden');

		if (this.addPlayerTriggerButton) {
			this.addPlayerTriggerButton.classList.remove('lta-btn--primary');
			this.addPlayerTriggerButton.classList.add('lta-btn--link');
			this.addPlayerTriggerButton.classList.add('is-list');
		}
	}

	hidePlayerApiError() {
		const errorContainer = SelectorEngine.findOne('.p-checkout__player-api-error', this.wrapper);

		if (!errorContainer) return;

		errorContainer.innerHTML = '';
		errorContainer.classList.add('u-hidden');
	}

	renderSaveCards() {
		this.savedCardsList.innerHTML += this.savedCardsData.map((data) => this.renderSavedCard(data)).join('');
		this.buttonClassToggleSavedCard();
		this.savedCardListButtons = SelectorEngine.find('input[name="saved-card-details"]', this.savedCardsList);
		if (this.savedCardsList) {
			this.formElementsList = {
				...this.formElementsList,
				savedCardsList: {
					element: this.savedCardsList,
					formElement: this.savedCardListButtons,
					inputType: SELECTOR_RADIO,
					errorMessage: 'Please select one saved card option',
					hasIcon: false
				}
			};
		}
		if (this.savedCardListButtons) {
			for (const radioButton of this.savedCardListButtons) {
				EventHandler.on(radioButton, CLICK_EVENT, this.savedCardClickHandler.bind(this));
				if (radioButton.checked) {
					radioButton.click();
				}
			}
		}
	}

	buttonClassToggleSavedCard() {
		this.savedCards = SelectorEngine.find('.p-checkout__saved-card-details', this.playerList);
		for (const card of this.savedCards) {
			EventHandler.on(card, CLICK_EVENT, this.selectCard.bind(this));
		}
	}

	savedCardClickHandler(event) {
		event.stopPropagation();
		this.addClassSelected(event, this.savedCards);
		this.validInputValue(this.formElementsList.savedCardsList);
	}

	renderSavedCard(savedCardData) {
		return `
		<div class="p-checkout__saved-card-details ${
			this.selectedPlayerDataID === savedCardData.CardTokenId ? CARD_SELECTED_CLASS : ''
		} lta-form-check lta-form-check u-hstack g-col-12 g-col-md-6 u-h-100 u-py-1">
			<input
				class="lta-form-check-input u-mr-2"
				role="radio"
				type="radio"
				name="saved-card-details"
				value="${savedCardData.CardTokenId}"
				aria-label=""
				data-player-id="${savedCardData.CardTokenId}" 
				${this.selectedPlayerDataID === savedCardData.CardTokenId ? 'checked' : ''}/>
					<div class="p-checkout__saved-card-details-record u-bg-background-blue u-px-3 u-py-2 u-rounded u-h-100">
						<div class="u-caption2 u-text-grey-lta">**** **** **** ${savedCardData?.LastFour}</div>
						<div class="u-caption2 u-text-grey-lta">Exp: ${savedCardData?.ExpiryMonth}/${savedCardData?.ExpiryYear}</div>
						<div class="u-caption2 u-text-grey-lta">${savedCardData.Name}</div>
					</div>
			</div>`;
	}

	matchAddressValues(address, newAddress) {
		if (!address || !newAddress) {
			return false;
		}

		const addressFields = pickComparisonFields(address);
		return pickComparisonFields(newAddress).every((newValue, index) => newValue === addressFields[index]);
	}

	displayPaymentSection(shouldShow) {
		this.paymentSection.classList.toggle(ClassNames.Hidden, !shouldShow);
	}

	displayCourtPlayerCountUnder18(shouldShow) {
		this.courtPlayerCountUnder18.classList.toggle(ClassNames.Hidden, !shouldShow);
	}

	displayCourtHousholdPlayerDetails(shouldShow) {
		this.courtHouseholdPlayerDetails.classList.toggle(ClassNames.Hidden, !shouldShow);
	}

	displayCourtAdditionalPlayerDetails(shouldShow) {
		this.courtAdditionalPlayerDetails.classList.toggle(ClassNames.Hidden, !shouldShow);
	}

	displayYouthContainer(shouldShow) {
		this.youthContainer.classList.toggle(ClassNames.Hidden, !shouldShow);
	}

	displayYouthBookingPlayerDetails(shouldShow) {
		this.playerDetails.classList.toggle(ClassNames.Hidden, !shouldShow)
	}

	toggleAddressAccordion(shouldShow) {
		if (this.accordionButton) {
			this.accordionButton.classList.toggle('no-events', !shouldShow);
		}
	}

	async submitForm(event) {
		const { target } = event.currentTarget.dataset;
		const formData = Object.fromEntries(new FormData(this.addressForm).entries());
		try {
			const submitted = await Request.post('/api/account/personal', {
				address: formData
			});
			this.address = formData;

			if (submitted && target) {
				const rootUrl = window.location.origin;
				window.location.href = `${rootUrl}${target}`;
			}
		} catch {
			if (this.errorWrapper) {
				this.errorWrapper.classList.remove(ClassNames.Hidden);
			}
		}
	}
}
const checkout = new Checkout({
	selectors: {
		wrapper: SELECTOR_WRAPPER,
		courtAdditionalPlayerDetails: SELECTOR_COURT_PLAYER_DETAILS,
		courtPlayerCountUnder18: SELECTOR_COURT_PALYER_COUNT_UNDER_18,
		courtHouseholdPlayerDetails: SELECTOR_COURT_HOUSEHOLD_PLAYER_DEtAILS,
		paymentSection: SELECTOR_PAYMENT_SECTION,
		errorWrapper: SELECTOR_ERROR_WRAPPER
	}
});
export default checkout;
